import {InjectionToken} from '@angular/core';
import {FormGroupContext} from "./form-group-context.interface";

export const FORM_GROUP_CONTEXT = new InjectionToken<FormGroupContext>('FormGroupContext');
